import * as Yup from 'yup'

const CmsHomepageSectionCommunityFavoriteFormSchema = Yup.object().shape({
  label: Yup.string().required('Required')
})

export default CmsHomepageSectionCommunityFavoriteFormSchema